import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PopupTrigger from './PopupTrigger';
import MobileNavigation from './MobileNavigation';
import Logo from './Logo';

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/about", label: "About Us" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact Us" },
];

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  return (
    <PopupTrigger>
      <div className="min-h-screen flex flex-col bg-black text-white">
        <header className="bg-gray-900 shadow-lg sticky top-0 z-50 border-b border-gray-800">
          <nav className="container mx-auto flex items-center justify-between py-4 px-6">
            <Link to="/" className="hover:opacity-80 transition-opacity flex-shrink-0 mr-8">
              <Logo size="lg" />
            </Link>
            <ul className="hidden md:flex gap-6 flex-1 justify-center">
              {navLinks.map(link => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className={`px-3 py-2 rounded-lg transition-all duration-300 font-medium ${
                      location.pathname === link.to
                        ? "bg-amber-800 text-white shadow-lg border border-amber-600"
                        : "text-gray-300 hover:text-amber-400 hover:bg-gray-800"
                    }`}
                    aria-current={location.pathname === link.to ? "page" : undefined}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="hidden md:block flex-shrink-0">
              <Link to="/contact">
                <button className="px-6 py-2 rounded-lg bg-amber-800 hover:bg-amber-700 text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-amber-600/50 border border-amber-600 transform hover:scale-105">
                  Get Free Quote
                </button>
              </Link>
            </div>
            <MobileNavigation />
          </nav>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="bg-gray-900 text-white py-8 border-t border-gray-800">
        <div className="container mx-auto px-6 text-center">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold text-amber-400 mb-4">Low Cost Framing</h3>
              <p className="text-gray-300 text-sm">
                Professional framing services backed by Woodhenge Builders' 20+ years of expertise.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-bold text-amber-400 mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                {navLinks.map(link => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-gray-300 hover:text-amber-400 transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold text-amber-400 mb-4">Contact Info</h4>
              <div className="space-y-2 text-sm text-gray-300">
                <p>(123) 456-7890</p>
                <p>info@roughframing.com</p>
                <p>123 Main Street<br />City, State 12345</p>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-bold text-amber-400 mb-4">Business Hours</h4>
              <div className="space-y-2 text-sm text-gray-300">
                <p>Mon-Fri: 7:00 AM - 5:00 PM</p>
                <p>Saturday: 8:00 AM - 3:00 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8">
            <p className="text-sm text-gray-400">
              &copy; {new Date().getFullYear()} Low Cost Framing by Woodhenge Builders. All rights reserved.
            </p>
            <p className="mt-2">
              <a 
                href="http://www.woodhengebuilders.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-amber-400 hover:text-amber-300 transition-colors"
              >
                Visit Woodhenge Builders for full construction services
              </a>
            </p>
          </div>
        </div>
      </footer>
      </div>
    </PopupTrigger>
  );
};

export default MainLayout; 